import { render, staticRenderFns } from "./ShowroomWsButton001.vue?vue&type=template&id=bf37f02a"
import script from "./ShowroomWsButton001.vue?vue&type=script&lang=js"
export * from "./ShowroomWsButton001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports